import React, { useState } from 'react';
import img1 from '../../assets/floor_plan/vasudharini_presentation_plan_type_a.jpg';
import img2 from '../../assets/floor_plan/vasudharini_presentation_plan_type_b.jpg';
import img3 from '../../assets/floor_plan/vasudharini_presentation_plan_type_c.jpg';
import img4 from '../../assets/floor_plan/vasudharini_presentation_plan_type_d.jpg';
import img5 from '../../assets/floor_plan/vasudharini_presentation_plan_type_e.jpg';
import img6 from '../../assets/floor_plan/vasudharini_presentation_plan_type_f.jpg';
import img7 from '../../assets/floor_plan/vasudharini_presentation_plan_type_g.jpg';
import img8 from '../../assets/floor_plan/vasudharini_presentation_plan_type_a1.jpg';
import img9 from '../../assets/floor_plan/vasudharini_presentation_plan_type_b1.jpg';
import img10 from '../../assets/floor_plan/vasudharini_presentation_plan_type_c1.jpg';
import img11 from '../../assets/floor_plan/vasudharini_presentation_plan_type_d1.jpg';
import img12 from '../../assets/floor_plan/vasudharini_presentation_plan_type_e1.jpg';
import img13 from '../../assets/floor_plan/vasudharini_presentation_plan_type_f1.jpg';
import Heading from '../ui/Heading';
import FormDetailsPopup from '../ui/ViewFormPopup';
import FloorPlanPopup from '../ui/FloorPlanPopup';

const FloorPlans = () => {
  const [showFormPopup, setShowFormPopup] = useState(false);
  const [showFloorPlanPopup, setShowFloorPlanPopup] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  
  const floorPlanData = [
    { id: 1, image: img1, type: 'Type A', sqft: '1305' },
    { id: 2, image: img2, type: 'Type B', sqft: '1380' },
    { id: 3, image: img3, type: 'Type C', sqft: '1331' },
    { id: 4, image: img4, type: 'Type D', sqft: '1140' },
    { id: 5, image: img5, type: 'Type E', sqft: '1331' },
    { id: 6, image: img6, type: 'Type F', sqft: '1331' },
    { id: 7, image: img7, type: 'Type G', sqft: '1285' },
    { id: 8, image: img8, type: 'Type A1', sqft: '1305' },
    { id: 9, image: img9, type: 'Type B1', sqft: '1380' },
    { id: 10, image: img10, type: 'Type C1', sqft: '1331' },
    { id: 11, image: img11, type: 'Type D1', sqft: '1278' },
    { id: 12, image: img12, type: 'Type E1', sqft: '1285' },
    { id: 13, image: img13, type: 'Type F1', sqft: '1278' },
  ];

  // Handle plan card click - opens form popup first
  const handlePlanClick = (plan) => {
    setSelectedPlan(plan);
    setShowFormPopup(true);
  };

  // Handle form submission success - closes form popup and opens floor plan popup
  const handleFormSubmitSuccess = (formData) => {
    setShowFormPopup(false);
    // Small delay to ensure smooth transition between popups
    setTimeout(() => {
      setShowFloorPlanPopup(true);
    }, 100);
  };

  // Handle form popup close
  const handleFormClose = () => {
    setShowFormPopup(false);
    setSelectedPlan(null);
  };

  // Handle floor plan popup close
  const handleFloorPlanClose = () => {
    setShowFloorPlanPopup(false);
    setSelectedPlan(null);
  };


  const getTypeLetterOnly = (typeString) => {
    // Extract just the letter part (A, B, C, etc.) from the type string
    return typeString.replace('Type ', '');
  };

  return (
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <Heading level={2} className='text-center'>Floor Plans</Heading>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-6">
          {floorPlanData.map((plan) => (
            <div
              key={plan.id}
              className="bg-white group rounded-lg border-4 hover:border-yellow-200 transition-all duration-300 cursor-pointer flex flex-col justify-between overflow-hidden shadow-sm hover:shadow-md"
              onClick={() => handlePlanClick(plan)}
            >
              <div className="p-2 sm:p-5">
                <div className="flex justify-between items-start mb-4">
                  <div className="flex flex-col items-center">
                    <h3 className="text-xs uppercase text-gray-500 mb-1">Type</h3>
                    <div className="bg-yellow-50 rounded-full w-10 sm:w-16 h-10 sm:h-16 flex items-center justify-center">
                      <p className="text-3xl font-bold text-yellow-600">{getTypeLetterOnly(plan.type)}</p>
                    </div>
                  </div>
                  <div className="flex flex-col items-center">
                    <h3 className="text-xs uppercase text-gray-500 mb-1">SQFT</h3>
                    <p className="text-xl font-medium text-gray-800">{plan.sqft}</p>
                  </div>
                </div>
              </div>
              <button className="w-full bg-yellow-50 text-yellow-600 text-sm font-medium py-3 transition-colors duration-200 group-hover:bg-yellow-200">
                View Plan
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Form Details Popup - Shows first when user clicks on a plan */}
      <FormDetailsPopup
        isOpen={showFormPopup}
        onClose={handleFormClose}
        onSubmitSuccess={handleFormSubmitSuccess}
        planType={selectedPlan?.type}
      />

      {/* Floor Plan Popup - Shows only after form submission */}
      <FloorPlanPopup
        isOpen={showFloorPlanPopup}
        onClose={handleFloorPlanClose}
        planData={selectedPlan}
      />
    </section>
  );
};

export default FloorPlans;